import { render, staticRenderFns } from "./ConfirmPlan.vue?vue&type=template&id=16aa56f6&"
import script from "./ConfirmPlan.vue?vue&type=script&lang=js&"
export * from "./ConfirmPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports